import { clearSearchBox } from '../actions/publicActions';
import { defaultSearchStore, getStore } from '../store/store';
import { map } from 'mobx';
import { mutator } from 'satcheljs';
export default mutator(clearSearchBox, function () {
    var searchStore = getStore();
    // Clear suggestion pills.
    searchStore.suggestionPillIds = defaultSearchStore.suggestionPillIds;
    searchStore.suggestionPills = map();
    // Clear plain text search query.
    searchStore.searchText = defaultSearchStore.searchText;
});
//# sourceMappingURL=clearSearchBoxMutator.js.map